<template>
  <div class="content blacklist">
    <div class="header">
      黑名单
    </div>
    <template>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="date" label="用户头像" width="240"></el-table-column>
        <el-table-column prop="name" label="用户昵称" width="240"></el-table-column>
        <el-table-column prop="name" label="违规帖子" width="240"></el-table-column>
        <el-table-column prop="name" label="拉黑时间" width="240"></el-table-column>
        <el-table-column prop="address" label="操作"></el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
       tableData: []
    };
  },
  mounted() {},
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    border-bottom: 0;
    background-color: #f8f8f8;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .header:after{
    content: '';
    position: absolute;
    width: 4px;
    height: 16px;
    background: #1AB394;
    border-radius: 30%;
    top: 50%;
    left: 10px;
    margin-top: -8px;
  }
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
}
</style>